import uaParser from 'ua-parser-js';
import values from 'lodash/values';
import toLower from 'lodash/toLower';

import { SUPPORTED_BROWSERS } from '../common/constants';

const { browser, os } = uaParser(window.navigator.userAgent);

/**
 * @typedef {Object} Browser
 * @property {string} name - The browser's name
 * @property {string} version - The browser's version
 *
 */

/**
 * Returns true if CP is running on mobile and false otherwise.
 * To know that, we're using User-Agent detection techniques from ua-parser-js.
 *
 * @returns {boolean} true if CP is running on Android or iOS, and false otherwise.
 */
export const isMobile = () =>
	!!os &&
	!!os.name &&
	(toLower(os.name) === 'android' || toLower(os.name) === 'ios');

/**
 * Given a browser whitelist object and a browser object, it'll return true if
 * the browser is whitelisted.
 *
 * @param {Object} whitelist - The browser's whitelist (DESKTOP or MOBILE)
 * @param {Browser} browser - The current browser object from ua-parser-js
 *
 * @returns {boolean} True if the browser is whitelisted
 */
const isInBrowserWhitelist = (whitelist, browser) =>
	browser &&
	browser.name &&
	values(whitelist)
		.map(({ id }) => id)
		.includes(browser.name);

/**
 * @returns {boolean} True if browser is whitelisted or false otherwise.
 */
export const isBrowserSupported = () =>
	isMobile()
		? isInBrowserWhitelist(SUPPORTED_BROWSERS.MOBILE, browser)
		: isInBrowserWhitelist(SUPPORTED_BROWSERS.DESKTOP, browser);
